const _ = "_flex_anl5f_7", l = "_fill_anl5f_13", a = "_inline_anl5f_24", n = "_column_anl5f_27", x = {
  flex: _,
  fill: l,
  inline: a,
  column: n,
  "column-reverse": "_column-reverse_anl5f_30",
  "row-reverse": "_row-reverse_anl5f_33",
  "wrap-reverse": "_wrap-reverse_anl5f_36",
  "wrap-nowrap": "_wrap-nowrap_anl5f_39",
  "align-start": "_align-start_anl5f_45",
  "align-center": "_align-center_anl5f_48",
  "align-end": "_align-end_anl5f_51",
  "align-baseline": "_align-baseline_anl5f_54",
  "align-stretch": "_align-stretch_anl5f_57",
  "align-content-start": "_align-content-start_anl5f_60",
  "align-content-center": "_align-content-center_anl5f_63",
  "align-content-end": "_align-content-end_anl5f_66",
  "align-content-stretch": "_align-content-stretch_anl5f_69",
  "align-content-baseline": "_align-content-baseline_anl5f_72",
  "align-content-space-around": "_align-content-space-around_anl5f_75",
  "align-content-space-between": "_align-content-space-between_anl5f_78",
  "align-content-space-evenly": "_align-content-space-evenly_anl5f_81",
  "justify-start": "_justify-start_anl5f_84",
  "justify-center": "_justify-center_anl5f_87",
  "justify-end": "_justify-end_anl5f_90",
  "justify-space-around": "_justify-space-around_anl5f_93",
  "justify-space-between": "_justify-space-between_anl5f_96",
  "justify-space-evenly": "_justify-space-evenly_anl5f_99",
  "center-md": "_center-md_anl5f_102",
  "center-lg": "_center-lg_anl5f_106",
  "center-xl": "_center-xl_anl5f_107",
  "center-xxl": "_center-xxl_anl5f_108",
  "xs-10.2": "_xs-10.2_anl5f_131",
  "xs-2.1": "_xs-2.1_anl5f_132",
  "xs-3.9": "_xs-3.9_anl5f_139",
  "xs-9.3": "_xs-9.3_anl5f_140",
  "xs-4.8": "_xs-4.8_anl5f_143",
  "xs-8.4": "_xs-8.4_anl5f_144",
  "xs-5.7": "_xs-5.7_anl5f_147",
  "xs-7.5": "_xs-7.5_anl5f_148",
  "xs-1": "_xs-1_anl5f_131",
  "xs-2": "_xs-2_anl5f_132",
  "xs-3": "_xs-3_anl5f_139",
  "xs-4": "_xs-4_anl5f_143",
  "xs-6": "_xs-6_anl5f_175",
  "xs-row-gap-none": "_xs-row-gap-none_anl5f_178",
  "xs-col-gap-none": "_xs-col-gap-none_anl5f_181",
  "xs-row-gap-xs": "_xs-row-gap-xs_anl5f_187",
  "xs-col-gap-xs": "_xs-col-gap-xs_anl5f_190",
  "xs-row-gap-sm": "_xs-row-gap-sm_anl5f_196",
  "xs-col-gap-sm": "_xs-col-gap-sm_anl5f_199",
  "xs-row-gap-md": "_xs-row-gap-md_anl5f_205",
  "xs-col-gap-md": "_xs-col-gap-md_anl5f_208",
  "xs-row-gap-lg": "_xs-row-gap-lg_anl5f_214",
  "xs-col-gap-lg": "_xs-col-gap-lg_anl5f_217",
  "xs-row-gap-xl": "_xs-row-gap-xl_anl5f_223",
  "xs-col-gap-xl": "_xs-col-gap-xl_anl5f_226",
  "sm-2.1": "_sm-2.1_anl5f_233",
  "sm-10.2": "_sm-10.2_anl5f_234",
  "sm-3.9": "_sm-3.9_anl5f_241",
  "sm-9.3": "_sm-9.3_anl5f_242",
  "sm-4.8": "_sm-4.8_anl5f_249",
  "sm-8.4": "_sm-8.4_anl5f_250",
  "sm-5.7": "_sm-5.7_anl5f_257",
  "sm-7.5": "_sm-7.5_anl5f_258",
  "sm-1": "_sm-1_anl5f_234",
  "sm-2": "_sm-2_anl5f_233",
  "sm-3": "_sm-3_anl5f_241",
  "sm-4": "_sm-4_anl5f_249",
  "sm-6": "_sm-6_anl5f_277",
  "sm-row-gap-none": "_sm-row-gap-none_anl5f_280",
  "sm-col-gap-none": "_sm-col-gap-none_anl5f_283",
  "sm-row-gap-xs": "_sm-row-gap-xs_anl5f_289",
  "sm-col-gap-xs": "_sm-col-gap-xs_anl5f_292",
  "sm-row-gap-sm": "_sm-row-gap-sm_anl5f_298",
  "sm-col-gap-sm": "_sm-col-gap-sm_anl5f_301",
  "sm-row-gap-md": "_sm-row-gap-md_anl5f_307",
  "sm-col-gap-md": "_sm-col-gap-md_anl5f_310",
  "sm-row-gap-lg": "_sm-row-gap-lg_anl5f_316",
  "sm-col-gap-lg": "_sm-col-gap-lg_anl5f_319",
  "sm-row-gap-xl": "_sm-row-gap-xl_anl5f_325",
  "sm-col-gap-xl": "_sm-col-gap-xl_anl5f_328",
  "md-2.1": "_md-2.1_anl5f_336",
  "md-10.2": "_md-10.2_anl5f_337",
  "md-3.9": "_md-3.9_anl5f_344",
  "md-9.3": "_md-9.3_anl5f_345",
  "md-4.8": "_md-4.8_anl5f_352",
  "md-8.4": "_md-8.4_anl5f_353",
  "md-5.7": "_md-5.7_anl5f_360",
  "md-7.5": "_md-7.5_anl5f_361",
  "md-1": "_md-1_anl5f_337",
  "md-2": "_md-2_anl5f_336",
  "md-3": "_md-3_anl5f_344",
  "md-4": "_md-4_anl5f_352",
  "md-6": "_md-6_anl5f_380",
  "md-row-gap-none": "_md-row-gap-none_anl5f_383",
  "md-col-gap-none": "_md-col-gap-none_anl5f_386",
  "md-row-gap-xs": "_md-row-gap-xs_anl5f_392",
  "md-col-gap-xs": "_md-col-gap-xs_anl5f_395",
  "md-row-gap-sm": "_md-row-gap-sm_anl5f_401",
  "md-col-gap-sm": "_md-col-gap-sm_anl5f_404",
  "md-row-gap-md": "_md-row-gap-md_anl5f_410",
  "md-col-gap-md": "_md-col-gap-md_anl5f_413",
  "md-row-gap-lg": "_md-row-gap-lg_anl5f_419",
  "md-col-gap-lg": "_md-col-gap-lg_anl5f_422",
  "md-row-gap-xl": "_md-row-gap-xl_anl5f_428",
  "md-col-gap-xl": "_md-col-gap-xl_anl5f_431",
  "lg-2.1": "_lg-2.1_anl5f_439",
  "lg-10.2": "_lg-10.2_anl5f_440",
  "lg-3.9": "_lg-3.9_anl5f_447",
  "lg-9.3": "_lg-9.3_anl5f_448",
  "lg-4.8": "_lg-4.8_anl5f_455",
  "lg-8.4": "_lg-8.4_anl5f_456",
  "lg-5.7": "_lg-5.7_anl5f_463",
  "lg-7.5": "_lg-7.5_anl5f_464",
  "lg-1": "_lg-1_anl5f_440",
  "lg-2": "_lg-2_anl5f_439",
  "lg-3": "_lg-3_anl5f_447",
  "lg-4": "_lg-4_anl5f_455",
  "lg-6": "_lg-6_anl5f_483",
  "lg-row-gap-none": "_lg-row-gap-none_anl5f_486",
  "lg-col-gap-none": "_lg-col-gap-none_anl5f_489",
  "lg-row-gap-xs": "_lg-row-gap-xs_anl5f_495",
  "lg-col-gap-xs": "_lg-col-gap-xs_anl5f_498",
  "lg-row-gap-sm": "_lg-row-gap-sm_anl5f_504",
  "lg-col-gap-sm": "_lg-col-gap-sm_anl5f_507",
  "lg-row-gap-md": "_lg-row-gap-md_anl5f_513",
  "lg-col-gap-md": "_lg-col-gap-md_anl5f_516",
  "lg-row-gap-lg": "_lg-row-gap-lg_anl5f_522",
  "lg-col-gap-lg": "_lg-col-gap-lg_anl5f_525",
  "lg-row-gap-xl": "_lg-row-gap-xl_anl5f_531",
  "lg-col-gap-xl": "_lg-col-gap-xl_anl5f_534",
  "xl-2.1": "_xl-2.1_anl5f_542",
  "xl-10.2": "_xl-10.2_anl5f_543",
  "xl-3.9": "_xl-3.9_anl5f_550",
  "xl-9.3": "_xl-9.3_anl5f_551",
  "xl-4.8": "_xl-4.8_anl5f_558",
  "xl-8.4": "_xl-8.4_anl5f_559",
  "xl-5.7": "_xl-5.7_anl5f_566",
  "xl-7.5": "_xl-7.5_anl5f_567",
  "xl-1": "_xl-1_anl5f_543",
  "xl-2": "_xl-2_anl5f_542",
  "xl-3": "_xl-3_anl5f_550",
  "xl-4": "_xl-4_anl5f_558",
  "xl-6": "_xl-6_anl5f_586",
  "xl-row-gap-none": "_xl-row-gap-none_anl5f_589",
  "xl-col-gap-none": "_xl-col-gap-none_anl5f_592",
  "xl-row-gap-xs": "_xl-row-gap-xs_anl5f_598",
  "xl-col-gap-xs": "_xl-col-gap-xs_anl5f_601",
  "xl-row-gap-sm": "_xl-row-gap-sm_anl5f_607",
  "xl-col-gap-sm": "_xl-col-gap-sm_anl5f_610",
  "xl-row-gap-md": "_xl-row-gap-md_anl5f_616",
  "xl-col-gap-md": "_xl-col-gap-md_anl5f_619",
  "xl-row-gap-lg": "_xl-row-gap-lg_anl5f_625",
  "xl-col-gap-lg": "_xl-col-gap-lg_anl5f_628",
  "xl-row-gap-xl": "_xl-row-gap-xl_anl5f_634",
  "xl-col-gap-xl": "_xl-col-gap-xl_anl5f_637",
  "xxl-2.1": "_xxl-2.1_anl5f_645",
  "xxl-10.2": "_xxl-10.2_anl5f_646",
  "xxl-3.9": "_xxl-3.9_anl5f_653",
  "xxl-9.3": "_xxl-9.3_anl5f_654",
  "xxl-4.8": "_xxl-4.8_anl5f_661",
  "xxl-8.4": "_xxl-8.4_anl5f_662",
  "xxl-5.7": "_xxl-5.7_anl5f_669",
  "xxl-7.5": "_xxl-7.5_anl5f_670",
  "xxl-1": "_xxl-1_anl5f_646",
  "xxl-2": "_xxl-2_anl5f_645",
  "xxl-3": "_xxl-3_anl5f_653",
  "xxl-4": "_xxl-4_anl5f_661",
  "xxl-6": "_xxl-6_anl5f_689",
  "xxl-12": "_xxl-12_anl5f_692",
  "xxl-row-gap-none": "_xxl-row-gap-none_anl5f_695",
  "xxl-col-gap-none": "_xxl-col-gap-none_anl5f_698",
  "xxl-row-gap-xs": "_xxl-row-gap-xs_anl5f_704",
  "xxl-col-gap-xs": "_xxl-col-gap-xs_anl5f_707",
  "xxl-row-gap-sm": "_xxl-row-gap-sm_anl5f_713",
  "xxl-col-gap-sm": "_xxl-col-gap-sm_anl5f_716",
  "xxl-row-gap-md": "_xxl-row-gap-md_anl5f_722",
  "xxl-col-gap-md": "_xxl-col-gap-md_anl5f_725",
  "xxl-row-gap-lg": "_xxl-row-gap-lg_anl5f_731",
  "xxl-col-gap-lg": "_xxl-col-gap-lg_anl5f_734",
  "xxl-row-gap-xl": "_xxl-row-gap-xl_anl5f_740",
  "xxl-col-gap-xl": "_xxl-col-gap-xl_anl5f_743"
};
export {
  n as column,
  x as default,
  l as fill,
  _ as flex,
  a as inline
};
//# sourceMappingURL=flex.module.less.js.map
